import { Drawer, Divider } from '@mantine/core';
import { ReactElement } from 'react';
import { OneTimeAvailabilityForm } from '@/pages/SchedulingPage/Availability/OneTimeAvailabilityForm';
import { PractitionerWithRole } from '@/pages/SchedulingPage/types';

interface TimeBlockDrawerProps {
  opened: boolean;
  onClose: () => void;
  /** Slot id when editing an existing block; null/undefined for a new block. */
  slotIdToEdit?: string | null;
  onSaveSuccess: () => void;
  practitioners: PractitionerWithRole[];
}

/**
 * Drawer for creating or editing a single procedure time block. Wraps the shared
 * one-time availability form (no weekly recurrence — this admin surface only manages
 * individual procedure windows). When editing, the form derives the provider from the
 * slot's schedule, so no pre-selected practitioner is required.
 */
export function TimeBlockDrawer({
  opened,
  onClose,
  slotIdToEdit = null,
  onSaveSuccess,
  practitioners,
}: TimeBlockDrawerProps): ReactElement {
  return (
    <Drawer.Root opened={opened} onClose={onClose} position="right" size="sm">
      <Drawer.Overlay />
      <Drawer.Content>
        <Drawer.Header>
          <Drawer.Title fw="bold">{slotIdToEdit ? 'Edit time block' : 'New time block'}</Drawer.Title>
          <Drawer.CloseButton />
        </Drawer.Header>
        <Divider />
        <Drawer.Body>
          {/* keyed so the form fully resets between create/edit and between different slots */}
          <OneTimeAvailabilityForm
            key={slotIdToEdit ?? 'new'}
            initialPractitioner={null}
            slotIdToEdit={slotIdToEdit}
            onClose={onClose}
            onSaveSuccess={onSaveSuccess}
            practitioners={practitioners}
            proceduresOnly
          />
        </Drawer.Body>
      </Drawer.Content>
    </Drawer.Root>
  );
}
